import React from "react";
import { Button, Spinner } from "reactstrap";
import { CustomButtonProps } from "../../../Type";
import CustomSpinner from "../Spinner/SpinnerCustom";

const CustomButton = ({
  label,
  isLoading,
  className,
  color,
  handleSubmit,
  onClick,
  disabled,
  type = "submit",
}: CustomButtonProps) => {
  return (
    <Button
      type={type}
      className={className}
      color={color}
      disabled={isLoading || disabled} 
      onClick={onClick || handleSubmit}
    >
      {isLoading ? <CustomSpinner /> : label}
    </Button>
  );
};

export default CustomButton;
